"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Model_1 = require("../Model");
const AnimationExceptions_1 = require("./AnimationExceptions");
class Animation extends Model_1.default {
    /**
     *
     * @param {Types.Animation.Timings} [timings]
     * @memberof Animation
     */
    constructor(timings, easings, timingUnit, deafultAddUnit) {
        super();
        /**
         *
         *
         * @protected
         * @type {Array<string>}
         * @memberof Animation
         */
        this.exportableProperties = ['timings', 'easings'];
        this.timings = {};
        this.easings = easings || {};
        this.timingUnit = timingUnit || 'ms';
        this.deafultAddUnit = deafultAddUnit || true;
        timings && Object.keys(timings).forEach(key => this.setTiming(key, timings[key]));
    }
    setTiming(name, value) {
        this.timings[name] = typeof value === 'string' ? parseFloat(this.stringToTimingUnit(value)) : value;
    }
    getTiming(name, withoutUnit = this.deafultAddUnit) {
        if (!(name in this.timings)) {
            throw new AnimationExceptions_1.TimingNotFoundException(name);
        }
        return withoutUnit ? this.timings[name] : this.timings[name] + this.timingUnit;
    }
    setEasing(name, value) {
        this.easings[name] = value;
    }
    getEasing(name) {
        if (!(name in this.easings)) {
            throw new AnimationExceptions_1.EasingNotFoundException(name);
        }
        return this.easings[name];
    }
    setTimingUnit(value) {
        this.timingUnit = value;
    }
    getTimingUnit() {
        return this.timingUnit;
    }
    setDeafultAddUnit(value) {
        this.deafultAddUnit = value;
    }
    getDeafultAddUnit() {
        return this.deafultAddUnit;
    }
    isInMilliseconds(str) {
        return str.match(/\d+ms/g) != null;
    }
    isInSeconds(str) {
        return str.match(/\d+s/g) != null;
    }
    /**
     * Converte un valore di tipo string (s, ms)
     *
     * @param {String} value
     * @return {Float} tempo
     */
    stringToTimingUnit(value) {
        const parsedValue = parseFloat(value);
        const valueIsInSecond = this.isInSeconds(value);
        if (this.timingUnit == 's') {
            return valueIsInSecond ? value : (parsedValue / 1000) + 's';
        }
        else {
            return valueIsInSecond ? (parsedValue * 1000) + 'ms' : value;
        }
    }
}
exports.default = Animation;
//# sourceMappingURL=Animation.js.map